import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../translation/namespace';
import { SkipLink, SkipLinkTarget } from '../../../_lib/components/SkipLink';

export function SkipableContent({ id, children }: PropsWithChildren<{ id: string }>) {
  const { t } = useTranslation(Namespace.ImageGallery);

  const skipLinkTarget = `image-gallery-end-${id}`;
  return (
    <div className="image-gallery__skipable-content">
      <SkipLink id={skipLinkTarget} focusTarget>
        {t('skipLinkText')}
      </SkipLink>
      {children}
      <SkipLinkTarget targetName={t('skipLinkTarget')} id={skipLinkTarget} />
    </div>
  );
}
